import React from "react";
import "./WhyUs.css";
import { scrollToElementById } from "../../../../utils/scrollToId";

import icon1 from "../../../../assets/images/academy/ic1.svg";
import icon2 from "../../../../assets/images/academy/ic2.svg";
import icon3 from "../../../../assets/images/academy/ic3.svg";
import icon4 from "../../../../assets/images/academy/ic4.svg";

const features = [
  {
    id: 1,
    title: "IRQGYP certified",
    icon: icon1, 
  },
  {
    id: 2,
    title: "Recognized in Iraq & region",
    icon: icon2,
  },
  {
    id: 3,
    title: "Professional results",
    icon: icon3,
  },
  {
    id: 4,
    title: "Employment guarantee",
    icon: icon4,
  },
];

const WhyUs = () => {
  const handleDiscoverCourses = () => {
    scrollToElementById("academy-courses");
  };

  return (
    <section className="whyus">
      <div className="whyus-container">
        
        {/* LEFT */}
        <div className="whyus-left">
          <span className="whyus-tag">WHY IRQGYP</span>

          <h2 className="whyus-title">
            Get a recognized <br />
            <span>certification in Iraq</span>
          </h2>

          <p className="whyus-text">
Your skills deserve recognition. IRQGYP's certification is your proof of expertise in drywall and modern construction systems.
          </p>

          <button type="button" className="buttongyp whyus-btn" onClick={handleDiscoverCourses}>
            Discover courses
          </button>
        </div>

        {/* RIGHT */}
        <div className="whyus-right">
          {features.map((item) => (
            <div key={item.id} className="whyus-card">
              
              {/* Replace src with your imported icons */}
              <img
                src={item.icon}
                alt=""
                className="whyus-icon"
              />

              <p className="whyus-cardText">{item.title}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyUs;